import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import RichText from "components/basic/richText";
import Checkbox from "components/basic/checkbox";
import FieldError from "components/basic/fieldError";

const TERMS_URL = "/terms";
const PRIVACY_URL = "/privacy";

interface DeclarationConsentProps {
  declarationAccepted: boolean;
  termsAccepted: boolean;
  onChange: (patch: {
    declarationAccepted?: boolean;
    termsAccepted?: boolean;
  }) => void;
  /** Set once the vendor tried to submit without both boxes ticked. */
  showErrors: boolean;
}

/** The two consents a vendor gives before the application is submitted. */
const DeclarationConsent: React.FC<DeclarationConsentProps> = ({
  declarationAccepted,
  termsAccepted,
  onChange,
  showErrors,
}) => {
  const { t } = useTranslation("auth");
  const theme = useTheme();
  // RichText fills the anchor with the translated link text.
  const link = (href: string) => (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a href={href} target="_blank" rel="noopener noreferrer" />
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
        paddingTop: theme.spacing(1),
      }}
    >
      <Checkbox
        isChecked={declarationAccepted}
        onChange={(checked) => onChange({ declarationAccepted: checked })}
        label={t("declaration.certify")}
      />
      <FieldError
        error={
          showErrors && !declarationAccepted
            ? t("declaration.certify_required")
            : null
        }
      />

      <Checkbox
        isChecked={termsAccepted}
        onChange={(checked) => onChange({ termsAccepted: checked })}
        label={
          <RichText
            t={t}
            i18nKey="declaration.agree"
            components={{ terms: link(TERMS_URL), privacy: link(PRIVACY_URL) }}
          />
        }
      />
      <FieldError
        error={
          showErrors && !termsAccepted ? t("declaration.agree_required") : null
        }
      />
    </div>
  );
};

export default DeclarationConsent;
